import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { FontIcon } from '@tekion/tmatter';
import styles from './popoverContent.module.scss';
var ICONS = {
  error: 'icon-cross',
  warning: 'icon-exclamation',
  info: 'icon-info'
};
var classMap = {
  error: styles.errorIcon,
  info: styles.infoIcon,
  warning: styles.warningIcon
};
export default function PopoverErrorContent(_ref) {
  var message = _ref.message,
    messageType = _ref.messageType;
  if (!message) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.popoverError, " flex")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.popoverIcon, classMap[messageType])
  }, /*#__PURE__*/React.createElement(FontIcon, null, ICONS[messageType])), /*#__PURE__*/React.createElement("span", {
    className: styles.errorText
  }, message));
}
PopoverErrorContent.propTypes = {
  message: PropTypes.string,
  messageType: PropTypes.string
};
PopoverErrorContent.defaultProps = {
  message: '',
  messageType: ''
};